import IndexDesign from '@/components/designs/IndexDesign.vue';
import ButtonsDesign from '@/components/designs/ButtonsDesign.vue';
import ComboDesign from '@/components/designs/ComboDesign.vue';
import TablesDesign from '@/components/designs/TablesDesign.vue';
import RolesDesign from '@/components/designs/RolesDesign.vue';
import SpinLoaderDesign from '@/components/designs/SpinLoaderDesign.vue';
import EmbeddableWidgetDesign from '@/components/designs/EmbeddableWidgetDesign.vue';
import PillsDesign from '@/components/designs/PillsDesign.vue';
import BulkSendDesign from '@/components/designs/BulkSendDesign.vue';
import ProgressSteppersDesign from '@/components/designs/ProgressSteppersDesign.vue';
import TabsDesign from '@/components/designs/TabsDesign.vue';
import IconsDesign from '@/components/designs/IconsDesign.vue';
import BrandDesign from '@/components/designs/BrandDesign.vue';
import UpsellsDesign from '@/components/designs/UpsellsDesign.vue';
import CommonStatesDesign from '@/components/designs/CommonStatesDesign.vue';
import EmptyStatesDesign from '@/components/designs/EmptyStatesDesign.vue';
import VideosDesign from '@/components/designs/VideosDesign.vue';
import CardsDesign from '@/components/designs/CardsDesign.vue';
import OrderableListDesign from '@/components/designs/OrderableListDesign.vue';
import ViewSwitcherListDesign from '@/components/designs/ViewSwitcherListDesign.vue';
import DropdownsDesign from '@/components/designs/DropdownsDesign.vue';
import FilePickerDesign from '@/components/designs/FilePickerDesign.vue';
import LoadingPageDesign from '@/components/designs/LoadingPageDesign.vue';
import TemplateSelectorDesign from '@/components/designs/TemplateSelectorDesign.vue';
import PartyRoleSelectorDesign from '@/components/designs/PartyRoleSelectorDesign.vue';
import AddPartyPasswordTabDesign from '@/components/designs/AddPartyPasswordTabDesign.vue';
import PartyCardDesign from '@/components/designs/PartyCardDesign.vue';
import PartiesDesign from '@/components/designs/PartiesDesign.vue';
import PartySummaryCard from '@/components/designs/PartySummaryCardDesign.vue';
import AddPartyPersonalMessageDesign from '@/components/designs/AddPartyPersonalMessageDesign.vue';
import ContactAutocompleteDesign from '@/components/designs/ContactAutocompleteDesign.vue';
import HelpLinkDesign from '@/components/designs/HelpLinkDesign.vue';

const routes = [
  {
    name: 'Designs',
    path: '/designs',
    component: IndexDesign,
  },
  {
    name: 'Buttons',
    path: '/designs/buttons',
    component: ButtonsDesign,
  },
  {
    name: 'Pills',
    path: '/designs/pills',
    component: PillsDesign,
  },
  {
    name: 'Roles',
    path: '/designs/roles',
    component: RolesDesign,
  },
  {
    name: 'Embeddable Widget',
    path: '/designs/embeddable-widget',
    component: EmbeddableWidgetDesign,
  },
  {
    name: 'Tables',
    path: '/designs/tables',
    component: TablesDesign,
  },
  {
    name: 'Spin Loader',
    path: '/designs/spin-loader',
    component: SpinLoaderDesign,
  },
  {
    name: 'Bulk Send',
    path: '/designs/bulk-send',
    component: BulkSendDesign,
  },
  {
    name: 'View Switcher List',
    path: '/designs/view-switcher-list',
    component: ViewSwitcherListDesign,
  },
  {
    name: 'Template Selector',
    path: '/designs/template-selector',
    component: TemplateSelectorDesign,
  },
  {
    name: 'Combo',
    path: '/designs/combo',
    component: ComboDesign,
  },
  {
    name: 'Progress Steppers',
    path: '/designs/progress-steppers',
    component: ProgressSteppersDesign,
  },
  {
    name: 'Tabs',
    path: '/designs/tabs',
    component: TabsDesign,
  },
  {
    name: 'Icons',
    path: '/designs/icons',
    component: IconsDesign,
  },
  {
    name: 'Signable Brand Components',
    path: '/designs/brand',
    component: BrandDesign,
  },
  {
    name: 'Product-Led Upsells Components',
    path: '/designs/upsells',
    component: UpsellsDesign,
  },
  {
    name: 'Common States',
    path: '/designs/common-states',
    component: CommonStatesDesign,
  },
  {
    name: 'Empty States',
    path: '/designs/empty-states',
    component: EmptyStatesDesign,
  },
  {
    name: 'Videos',
    path: '/designs/videos',
    component: VideosDesign,
  },
  {
    name: 'Cards',
    path: '/designs/cards',
    component: CardsDesign,
  },
  {
    name: 'Orderable List',
    path: '/designs/orderable-list',
    component: OrderableListDesign,
  },
  {
    name: 'Dropdowns',
    path: '/designs/dropdowns',
    component: DropdownsDesign,
  },
  {
    name: 'File Picker',
    path: '/designs/file-picker',
    component: FilePickerDesign,
  },
  {
    name: 'Loading Page',
    path: '/designs/loading-page',
    component: LoadingPageDesign,
  },
  {
    name: 'Add Party Password Tab ',
    path: '/designs/add-party-password-tab',
    component: AddPartyPasswordTabDesign,
  },
  {
    name: 'Add Party Personal Message Tab ',
    path: '/designs/add-party-personal-message-tab',
    component: AddPartyPersonalMessageDesign,
  },
  {
    name: 'Role Selector',
    path: '/designs/role-selector',
    component: PartyRoleSelectorDesign,
  },
  {
    name: 'Party Card',
    path: '/designs/party-card',
    component: PartyCardDesign,
  },
  {
    name: 'Parties',
    path: '/designs/parties',
    component: PartiesDesign,
  },
  {
    name: 'Party Summary Card',
    path: '/designs/party-summary-card',
    component: PartySummaryCard,
  },
  {
    name: 'Contact Autocomplete',
    path: '/designs/contact-autocomplete',
    component: ContactAutocompleteDesign,
  },
  {
    name: 'Help Link',
    path: '/designs/help-link',
    component: HelpLinkDesign,
  },
];

// Only export if not in production
const shouldExport =
  process.env.VUE_APP_ENV !== 'production' ||
  process.env.VUE_APP_IS_LOCAL === 'true';

export default shouldExport ? routes : [];
